import React from "react";
import BrandIcon from "../BrandIcon";
import Button from "elements/Button";
import { useSelector } from "react-redux";
import UserDropdown from "./UserDropdown";

export default function Navbar() {
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  return (
    <nav className="navbar navbar-expand-lg navbar-light py-3">
      <div className="container">
        <BrandIcon />
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasWithBothOptions"
          aria-controls="offcanvasWithBothOptions"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="true"
          tabIndex="-1"
          id="offcanvasWithBothOptions"
          aria-labelledby="offcanvasWithBothOptionsLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
              Offcanvas
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              {isAuthenticated ? (
                <UserDropdown />
              ) : (
                <Button className="btn" type="link" href="/login" isPrimary>
                  Login
                </Button>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
